export const home = {
  // Hero Section
  heroTitle: 'Superior Steel Fiber Solutions',
  heroSubtitle: 'Engineered for strength, designed for durability. DYNAMIX hooked-end steel fibers deliver exceptional performance in concrete reinforcement for critical infrastructure projects.',

  // Features
  featuresTitle: 'Why Choose DYNAMIX Steel Fibers',
  featuresSubtitle: 'Advanced engineering meets superior performance',

  feature1Title: 'Superior Tensile Strength',
  feature1Desc: 'High-grade steel with tensile strength of 1000-1200 MPa ensures maximum load-bearing capacity and structural integrity.',

  feature2Title: 'Optimized Hooked-End Design',
  feature2Desc: 'Engineered hook geometry provides exceptional anchorage in concrete matrix, preventing fiber pullout under stress.',

  feature3Title: 'Enhanced Crack Control',
  feature3Desc: 'Uniform fiber distribution creates a three-dimensional reinforcement network that effectively controls crack propagation.',

  feature4Title: 'Corrosion Resistant',
  feature4Desc: 'Premium steel composition with protective coating ensures long-term durability in harsh environmental conditions.',

  feature5Title: 'Easy Application',
  feature5Desc: 'Free-flowing fibers mix easily with concrete, ensuring uniform distribution without balling or clumping.',

  feature6Title: 'Cost-Effective',
  feature6Desc: 'Reduces labor costs and construction time while eliminating the need for traditional mesh reinforcement.',

  // Applications Preview
  applicationsTitle: 'Proven Applications',
  applicationsSubtitle: 'Trusted in critical infrastructure projects worldwide',

  app1Title: 'Industrial Floors',
  app1Desc: 'High-traffic warehouses and manufacturing facilities',

  app2Title: 'Tunnel Linings',
  app2Desc: 'Underground infrastructure and mining operations',

  app3Title: 'Dams & Hydraulic Structures',
  app3Desc: 'Large-scale water infrastructure and hydroelectric projects',

  app4Title: 'Precast Elements',
  app4Desc: 'Architectural and structural precast components',

  viewAllApplications: 'View All Applications',

  // Technical Excellence
  technicalTitle: 'Technical Excellence',
  technicalSubtitle: 'Manufactured to the highest international standards',

  tech1Title: 'ASTM A820 Certified',
  tech1Desc: 'Meets all requirements of ASTM A820 standard for steel fibers used in fiber-reinforced concrete.',

  tech2Title: 'ISO 9001 Quality',
  tech2Desc: 'Manufactured under strict ISO 9001 quality management system ensuring consistent product quality.',

  tech3Title: 'Advanced Testing',
  tech3Desc: 'Every batch undergoes rigorous testing for tensile strength, geometry, and performance characteristics.',

  tech4Title: 'Technical Support',
  tech4Desc: 'Expert engineering support for mix design, dosage calculation, and application guidance.',

  // CTA
  ctaTitle: 'Ready to Strengthen Your Project?',
  ctaSubtitle: 'Get expert consultation and technical support for your concrete reinforcement needs.',
  getInTouch: 'Get in Touch',
};
